// extracted by mini-css-extract-plugin
export default {"deductionContainer":"deductions_deductionContainer__MDY1e","tabList":"deductions_tabList__hbnQE","tab":"deductions_tab__4OBD8","active":"deductions_active__mrItc"};